export default function getFileNameExcludeExtension(fileName) {
  if (fileName) {
    const splitFileName = fileName.split('.');
    if (splitFileName.length > 1) {
      splitFileName.pop();
    }
    return splitFileName.join('.');
  }
  return fileName;
}
